(function () {
  function initIngredientsListSwiper(root) {
    root.querySelectorAll('.ctr-ingredients-list__carousel').forEach((el) => {
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 18,
        grabCursor: true,
        mousewheel: true,
      });
    });
  }

  function boot() {
    initIngredientsListSwiper(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelector && event.target.querySelector('.ctr-ingredients-list__carousel')) {
        initIngredientsListSwiper(event.target);
      }
    });
  }
})();
